import { Component, ElementRef, HostListener, OnInit, Output, ViewChild,EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonService } from 'src/app/core/helper/common.service';



@Component({
  selector: 'pmd-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss']
})
export class PmdEditorComponent implements OnInit {

  constructor(private router: Router, private sanitizer: DomSanitizer,
    public commonService:CommonService) { }

  @Input() clearEditorData=false;
  @Input() validation={
                      maxLength:500,
                      allowedFileType:".pdf, .png, .jpg, .jpeg",
                      };
  
  @Output() editorContentChange: EventEmitter<any> = new EventEmitter();
  @Output() editorFileArray: EventEmitter<any> = new EventEmitter();

  
  @ViewChild('editor', { static: true }) editor: ElementRef;
  attachedFiles: { name: string, url: string }[] = [];
  attachedFilesArray=[];
  fileInputValue: any;

  isBold: boolean = false;
  isItalic: boolean = false;
  isUnderline: boolean = false;
  isInsertOrderedList: boolean = false;
  isInsertUnorderedList: boolean = false;
  supportDescriptionLength=this.validation.maxLength;
  supportDescriptionRemainingLength=this.validation.maxLength;

  @HostListener('document:selectionchange', ['$event'])
  onSelectionChange(event: Event) {
    if (this.editor.nativeElement.contains(window.getSelection().anchorNode)) {
      this.updateActiveStates();
    }
  }

  ngOnInit() {
    this.editor.nativeElement.addEventListener('keypress', (event) => {
     if (this.editor.nativeElement.innerText.replace(/<\/?[^>]+(>|$)/g, "").length >= this.validation.maxLength) {
        //this.commonService.toasterService(0, "Max limit for the reply box is "+ this.validation.maxLength +" characters");
        event.preventDefault();
      }else{
        this.editorContentChange.emit(this.editor.nativeElement.innerText);
      }
    });
    /*this.editor.nativeElement.addEventListener('paste', (event) => { 
      if (this.editor.nativeElement.innerHTML.replace(/<\/?[^>]+(>|$)/g, "").trim().length > this.validation.maxLength) {
        this.commonService.toasterService(0, "Max limit for the reply box is "+ this.validation.maxLength +" characters");
        var truncatedValue=this.editor.nativeElement.innerHTML.substring(0,500);
        this.editorContentChange.emit(truncatedValue);
        // var clipboard = event.clipboardData,
        // text = clipboard.getData('Text');
        // event.target.value = text.substring(0,500);;
        event.preventDefault();
      }else{
        this.editorContentChange.emit(this.editor.nativeElement.innerHTML);
      }
    });*/
    this.editor.nativeElement.addEventListener('input', (event) => {
      this.supportDescriptionRemainingLength=(this.supportDescriptionLength-this.editor.nativeElement.innerText.replace(/<\/?[^>]+(>|$)/g, "").length);
      
      this.editorContentChange.emit(this.editor.nativeElement.innerText);
      // Handle content changes here
      //console.log(this.editor.nativeElement.innerHTML);
      
      //this.editorContentChange.emit(this.editor.nativeElement.innerHTML);
    });  
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.clearEditorData && changes.clearEditorData.currentValue) {
      if(changes.clearEditorData.currentValue==true){
        this.attachedFilesArray=[];
        this.attachedFiles=[];
        this.editor.nativeElement.innerHTML="";
      }
    }
  }
  


  formatText(command: string) {
    document.execCommand(command, false, null);
    this.updateActiveStates();
  }

  ngAfterViewInit() {
    this.updateActiveStates();
  }

  private updateActiveStates() {
    this.isBold = document.queryCommandState('bold');
    this.isItalic = document.queryCommandState('italic');
    this.isUnderline = document.queryCommandState('underline');
    this.isInsertOrderedList = document.queryCommandState('insertOrderedList');
    this.isInsertUnorderedList = document.queryCommandState('insertUnorderedList');
  }

  setHeading(level: number) {
    document.execCommand('formatBlock', false, 'h' + level);
  }

  setParagraph() {
    document.execCommand('formatBlock', false, 'p');
  }

  toggleList(command: string) {
    document.execCommand(command, false, null);
  }

  attachFiles(event: any) {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileExists = this.attachedFiles.some(attachedFile => attachedFile.name === file.name);
      if (!fileExists) {
        const url = URL.createObjectURL(file);
        this.attachedFiles.push({ name: file.name, url: url });
        this.attachedFilesArray.push(file)
        this.editorFileArray.emit(this.attachedFilesArray);
      } else {
        console.log(`File with the name ${file.name} is already attached.`);
      }
    }
    // Clear the input field
    event.target.value = '';
  }

  removeFile(file: { name: string, url: string }) {
    this.attachedFiles = this.attachedFiles.filter(f => f !== file);
    this.attachedFilesArray = this.attachedFilesArray.filter((item) => item.name !== file.name);
    this.editorFileArray.emit(this.attachedFilesArray);
    // Clear the file input to allow attaching more files
    this.fileInputValue = null;
  }

isShiftKeyPressed = false;
isCtrlOrMetaKeyPressed = false;

@HostListener('window:keydown', ['$event'])
keydownHandler(event: KeyboardEvent) {
  this.isShiftKeyPressed = event.shiftKey;
  this.isCtrlOrMetaKeyPressed = event.ctrlKey || event.metaKey;
}

  /*handlePaste(event: ClipboardEvent) {
    event.preventDefault();
  
    const clipboardData = event.clipboardData || (window as any).clipboardData; // For cross-browser compatibility
    if (clipboardData) {
      // Check if the user is pasting as plain text (Shift + Command/Ctrl + V)
      const isPlainTextPasting =
        this.isShiftKeyPressed && this.isCtrlOrMetaKeyPressed;
      const pastedHTML = clipboardData.getData('text/html');
      const pastedText = clipboardData.getData('text/plain'); // Use 'text' instead of 'text/plain'

      
      if (isPlainTextPasting) {
        // Use the 'insertText' command to insert plain text content
        document.execCommand('insertText', false, pastedText);
      } else {
        // Use the 'insertHTML' command to insert pasted HTML content
        document.execCommand('insertHTML', false, pastedHTML);
      }
    }
  }*/

  handlePaste(event){
    var text = (event.originalEvent || event).clipboardData.getData(
      "text/plain"
    );
    var totalLength=(this.editor.nativeElement.innerText.replace(/<\/?[^>]+(>|\n|$)/g, "").length + text.replace(/<\/?[^>]+(>|\n|$)/g, "").length);
   
    if (totalLength > this.validation.maxLength) {
      var truncatedValue=text.replace(/<\/?[^>]+(>|\n|$)/g, "").substring(0,(this.validation.maxLength-this.editor.nativeElement.innerText.replace(/<\/?[^>]+(>|\n|$)/g, "").length));
      this.editorContentChange.emit(truncatedValue);
      event.clipboardData.setData("text/plain", truncatedValue);
      document.execCommand("insertHTML", false, truncatedValue);
    }else{
      event.clipboardData.setData("text/plain", text);
      document.execCommand("insertHTML", false, text);
      this.editorContentChange.emit(text);
    }
    event.preventDefault();
   }

  

  selectHeadingLevel(event: any) {
    const selectedLevel = event.target.value;
    document.execCommand('formatBlock', false, selectedLevel);
  }

  insertLink() {
    const url = prompt('Enter the URL:');
    if (url) {
      document.execCommand('createLink', false, url);
    }
  }

  isImageFile(fileName: string): boolean {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp']; // Add more image extensions if needed
    const fileExtension = fileName.substring(fileName.lastIndexOf('.')).toLowerCase();
    return imageExtensions.includes(fileExtension);
  }

  selectedHeadingLevel: string;
  // selectHeadingLevel() {
  //   document.execCommand('formatBlock', false, this.selectedHeadingLevel);
  // }

  printHtmlContent() {
    // Get the HTML content from the editor
    const htmlContent = this.editor.nativeElement.innerText;
  
    // Create a new window to display the HTML content
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  
    // Print the content
    printWindow.print();
  
    // Close the new window after printing (optional)
    printWindow.close();
  }
  
  editorContent: SafeHtml = '';

  getHtmlContent() {
    if (this.editor) {
      this.editorContent = this.sanitizer.bypassSecurityTrustHtml(this.editor.nativeElement.innerText);
    } else {
      console.log("Rich text editor element is not available.");
    }
  }

  

  // onSubmit() {
  //   // Get the content of the editor
  //   this.editorContent = this.editor.nativeElement.innerHTML;

  //   // Set the content of another div (targetDivId) with the editor content
  //   const targetDiv = document.getElementById('targetDivId');
  //   if (targetDiv) {
  //     targetDiv.innerHTML = this.editorContent;
  //   }
  // }

}
